import React from "react";
import { Star, ExternalLink } from "lucide-react";
import { useSiteProfile } from "@/hooks/useSiteProfile";
import { GBP_URL, GBP_REVIEW_URL } from "@/lib/contact";

// Links to read our Google reviews and leave a new one.
// Set the real URLs on the Site Profile record; falls back to a Maps search.
export default function ReviewLinks({ className = "" }) {
  const profile = useSiteProfile();
  const query = encodeURIComponent(
    `${profile?.business_name || "Bluegrass Web Works"} ${profile?.address_locality || ""} ${profile?.address_region || ""}`
  );
  const readUrl =
    profile?.google_reviews_url || GBP_URL;
  const writeUrl = GBP_REVIEW_URL;

  return (
    <div className={`flex flex-wrap items-center gap-3 ${className}`}>
      <a
        href={writeUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent text-accent-foreground font-semibold hover:bg-accent/90 transition-colors"
      >
        <Star size={16} /> Leave a review
      </a>
      <a
        href={readUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-accent/30 text-accent font-semibold hover:bg-accent/5 transition-colors"
      >
        Read our Google reviews <ExternalLink size={15} />
      </a>
    </div>
  );
}